<template>
  <b-container>
    <b-row>
      <b-col align="right">
        <b-button variant="primary" @click.stop="modalFormOpenAdd($event.target)">
          Create
        </b-button>
      </b-col>
    </b-row>

    <b-row class="mt-3">
      <b-col>
        <b-alert variant="danger" dismissible :show="showAlert" @dismissed="showAlert = false">
          {{ alertMessage }}
        </b-alert>

        <b-table striped :items="users" :fields="fields" :busy="!loaded">
          <template #table-busy>
            <div class="text-center my-3">
              <b-spinner small /> Loading&hellip;
            </div>
          </template>
          <template #cell(buttons)="row">
            <div class="d-flex justify-content-end">
            <b-button-group>
              <b-button size="sm" variant="secondary"
                @click.stop="modalFormOpenEdit(row.item, row.index, $event.target)" class="mr-1">
                Edit
              </b-button>
              <b-button size="sm" variant="danger" @click.stop="modalDeleteOpen(row.item, row.index, $event.target)"
                class="mr-1">
                Remove
              </b-button>
            </b-button-group>
            </div>
          </template>
        </b-table>
      </b-col>
    </b-row>

    <b-modal id="modalForm" size="xl" @hide="modalFormReset" :title="modalForm.title" ok-variant="primary"
      @ok="createUser()">
      <b-form v-if="showForm">
        <b-form-input id="id" type="text" v-model="form.ID" hidden></b-form-input>

        <b-form-group id="nameInputGroup" label="Name" label-for="name">
          <b-form-input id="name" type="text" v-model="form.name" autocomplete="off"></b-form-input>
        </b-form-group>

        <b-form-group id="passwordInputGroup" label="Password" label-for="password">
          <b-form-input id="password" type="password" v-model="form.password"></b-form-input>
        </b-form-group>

        <b-form-group id="passwordConfirmationInputGroup" label="Password (Confirmation)" label-for="password-repeat">
          <b-form-input id="passwordConfirmation" type="password" v-model="form.passwordConfirmation"></b-form-input>
        </b-form-group>

        <b-form-group id="emailInputGroup" label="E-mail" label-for="email">
          <b-form-input id="email" type="text" v-model="form.email" autocomplete="off"></b-form-input>
        </b-form-group>

        <b-form-group label="E-mail notifications">
          <b-form-checkbox id="checkbox2" v-model="form.notify"></b-form-checkbox>
        </b-form-group>

        <b-form-group label="E-mail notification breakdown duration threshold" label-for="notifyDelay"
          description="Minimum 1 minute" append="minutes">
          <b-input-group append="minutes">
            <b-form-input id="notifyDelay" type="number" min="1" v-model.number="form.notify_delay"></b-form-input>
          </b-input-group>
        </b-form-group>

        <b-form-group v-if="isAdmin" label="Admin">
          <b-form-checkbox id="checkbox1" v-model="form.admin"></b-form-checkbox>
        </b-form-group>

        <b-form-group v-if="form.ignoredElevators && form.ignoredElevators.length" label="Disabled">
          <b-list-group>
            <b-list-group-item v-for="ie in form.ignoredElevators" :key="ie.elevator_id"
              class="d-flex justify-content-between align-items-center">
              <span
                :style="form.elevatorRemovals.includes(ie.elevator_id) ? 'text-decoration:line-through;color:#aaa' : ''">{{
                  ie.elevator_name || ie.elevator_id }}</span>
              <b-button v-if="!form.elevatorRemovals.includes(ie.elevator_id)" size="sm" variant="outline-danger"
                @click="markElevatorForRemoval(ie.elevator_id)">Remove</b-button>
              <b-button v-else size="sm" variant="outline-secondary"
                @click="unmarkElevatorForRemoval(ie.elevator_id)">Undo</b-button>
            </b-list-group-item>
          </b-list-group>
        </b-form-group>


        <b-form-group v-if="form && form.groupRoles && form.groupRoles.length > 0" label="Groups">
          <b-input-group class="mb-2">
            <b-form-input v-model="groupFilter" placeholder="Filter groups..." autocomplete="off"></b-form-input>
            <b-input-group-append v-if="groupFilter">
              <b-button variant="outline-secondary" @click="groupFilter = ''">✕</b-button>
            </b-input-group-append>
          </b-input-group>
          <div class="group-picker">
            <div v-for="group in filteredGroupRoles" :key="group.id" class="group-picker-item"
              :class="{ selected: group.role !== null }">
              <b-form-checkbox :disabled="form.admin" :checked="group.role !== null"
                @change="toggleGroup(group, $event)" class="group-picker-label">{{ group.name }}</b-form-checkbox>
              <b-form-select v-if="group.role !== null" :disabled="form.admin" v-model="group.role"
                :options="availableRoles.filter(r => r.value !== null)" size="sm" class="group-picker-role"></b-form-select>
            </div>
            <div v-if="filteredGroupRoles.length === 0" class="text-muted p-2">No groups match.</div>
          </div>
          <small class="text-muted">{{form.groupRoles.filter(g => g.role !== null).length}} of {{
            form.groupRoles.length
            }} assigned</small>
        </b-form-group>
      </b-form>
    </b-modal>

    <b-modal id="modalDelete" @hide="modalDeleteReset" :title="modalDelete.title" ok-variant="danger"
      @ok="deleteUser(modalDelete)">
      <p>{{ modalDelete.content }}</p>
    </b-modal>
  </b-container>
</template>

<script>
import api from './api.js'
import auth from './auth.js'
import moment from 'moment';

export default {
  name: 'users',
  data() {
    return {
      loggedIn: auth.loggedIn(),
      modalForm: { title: '' },
      modalDelete: { title: '', content: '', user: null },
      loaded: false,
      users: [],
      groupsOptions: [],
      groupAdminGroupIds: [],
      groupFilter: '',
      showForm: true,
      showAlert: false,
      alertMessage: '',
      userToRemove: '',
      form: {
        ID: 0,
        name: '',
        password: '',
        passwordConfirmation: '',
        admin: false,
        email: '',
        notify: false,
        notify_delay: 5,
        groupRoles: [],
        ignoredElevators: [],
        elevatorRemovals: [],
      },
      allRoles: [
        { value: null, text: "" },
        { value: 1, text: "View" },
        { value: 2, text: "Audit" },
        { value: 3, text: "Edit" },
        { value: 4, text: "Expert" },
        { value: 5, text: "Admin" },
      ],
    }
  },
  computed: {
    fields() {
      const base = [
        { key: 'name', sortable: true },
        { key: 'email', sortable: true },
        { key: 'notify', sortable: true, formatter: v => v ? 'Yes' : 'No' },
      ];
      if (this.isAdmin) {
        base.push({ key: 'admin', sortable: true, formatter: v => v ? 'Yes' : 'No' });
      }
      base.push({ key: 'buttons', label: '', sortable: false, tdClass: 'text-right' });
      return base;
    },
    isAdmin() {
      return auth.admin();
    },
    isGroupAdmin() {
      return auth.groupAdmin();
    },
    // Roles available in the group picker dropdown.
    // Group admins can assign any role including Admin (5) within their scope.
    availableRoles() {
      return this.allRoles;
    },
    // Groups shown in the group picker.
    // Group admins only see groups they administer (role 5).
    scopedGroupsOptions() {
      if (this.isAdmin) return this.groupsOptions;
      return this.groupsOptions.filter(g => this.groupAdminGroupIds.includes(g.id));
    },
    filteredGroupRoles() {
      if (!this.form.groupRoles) return [];
      if (!this.groupFilter) return this.form.groupRoles;
      const f = this.groupFilter.toLowerCase();
      return this.form.groupRoles.filter(g => g.name.toLowerCase().includes(f));
    },
  },
  methods: {
    toggleGroup(group) {
      group.role = group.role === null ? 1 : null;
    },
    createUser() {
      this.showAlert = false;
      this.alertMessage = '';

      // Group admins must assign the user to at least one of their groups.
      if (this.isGroupAdmin && !this.isAdmin) {
        const hasGroupAssignment = this.form.groupRoles.some(g => g.role !== null);
        if (!hasGroupAssignment) {
          this.alertMessage = 'You must assign the user to at least one of your groups.';
          this.showAlert = true;
          return;
        }
      }
      if (this.form.notify_delay < 1) {
        this.alertMessage = 'E-mail notification breakdown duration threshold must be at least 1 minute.';
        this.showAlert = true;
        return;
      }
      if (this.form.ID != 0) {
        api.updateUser(this.form, response => {
          if (response.data == "OK") {
            const removals = [...this.form.elevatorRemovals];
            removals.forEach(id => api.adminUnignoreElevator(this.form.ID, id, () => { }));
            this.getUsers();
            this.form.name = '';
            this.form.password = '';
            this.form.passwordConfirmation = '';
            this.form.admin = false;
            this.form.email = '';
            this.form.notify = false;
            this.form.notify_delay = 5;
            this.form.groups = [];
            this.form.groupRoles = [];
            this.form.ignoredElevators = [];
            this.form.elevatorRemovals = [];
          } else {
            this.alertMessage = response.data.message;
            this.showAlert = true;
          }
        });
      } else {
        api.createUser(this.form, response => {
          if (response.data == "OK") {
            this.getUsers();
            this.form.name = '';
            this.form.password = '';
            this.form.passwordConfirmation = '';
            this.form.admin = false;
            this.form.email = '';
            this.form.notify = false;
            this.form.notify_delay = 5;
            this.form.groups = [];
          } else {
            this.alertMessage = response.data.message;
            this.showAlert = true;
          }
        });
      }
    },
    getUsers() {
      api.getUsers(users => {
        if (users.data) {
          this.users = users.data;
          this.loaded = true;
        } else {
          this.users = [];
          this.loaded = false;
        }
      })
    },
    modalFormOpenAdd(item, index, button) {
      this.modalForm.title = 'Create User';
      this.form.ID = 0;
      this.form.name = '';
      this.form.password = '';
      this.form.passwordConfirmation = '';
      this.form.email = '';
      this.form.notify = false;
      this.form.notify_delay = 5;
      this.form.admin = false;
      this.form.groupRoles = [];
      this.form.ignoredElevators = [];
      this.form.elevatorRemovals = [];
      this.scopedGroupsOptions.forEach(g => {
        this.form.groupRoles.push({ id: g.id, name: g.name, role: null });
      });
      this.$root.$emit('bv::show::modal', 'modalForm', button);
    },
    modalFormOpenEdit(item, index, button) {
      this.modalForm.title = 'Edit User';
      this.form.ID = item.ID;
      this.form.name = item.name;
      this.form.password = '';
      this.form.passwordConfirmation = '';
      this.form.admin = item.admin;
      this.form.email = item.email;
      this.form.notify = item.notify;
      this.form.notify_delay = item.notify_delay != null ? item.notify_delay : 5;
      this.form.groupRoles = [];
      this.form.ignoredElevators = [];
      this.form.elevatorRemovals = [];

      api.adminGetIgnoredElevators(item.ID, response => {
        if (Array.isArray(response.data)) {
          this.form.ignoredElevators = response.data;
        }
      });

      this.scopedGroupsOptions.forEach(g => {
        let gr = item.group_roles.find(gr => gr.group_id == g.id);
        let rid = gr ? gr.role_id : null;
        this.form.groupRoles.push({ id: g.id, name: g.name, role: rid });
      });

      this.$root.$emit('bv::show::modal', 'modalForm', button);
    },
    modalFormReset() {
      this.groupFilter = '';
    },
    markElevatorForRemoval(elevatorID) {
      this.form.elevatorRemovals.push(elevatorID);
    },
    unmarkElevatorForRemoval(elevatorID) {
      this.form.elevatorRemovals = this.form.elevatorRemovals.filter(id => id !== elevatorID);
    },
    modalDeleteOpen(item, index, button) {
      this.modalDelete.title = `Remove ${item.name}`;
      this.modalDelete.content = `Are you sure you want to remove user ${item.name}?`;
      this.modalDelete.user = item;
      this.$root.$emit('bv::show::modal', 'modalDelete', button);
    },
    modalDeleteReset() {
      this.modalDelete.title = '';
      this.modalDelete.content = '';
      this.modalDelete.user = null;
    },
    deleteUser(data) {
      api.deleteUser(data.user.ID, res => {
        this.getUsers();
      })
    },
    getGroups() {
      api.getGroups(groups => {
        if (groups.data) {
          this.groupsOptions = groups.data.map(g => {
            return { name: g.name, id: g.id, role: null };
          });
        }
      })
    },
    loadGroupAdminScope() {
      if (!this.isGroupAdmin) return;
      api.getProfile(response => {
        if (response.data && Array.isArray(response.data.group_admin_ids)) {
          this.groupAdminGroupIds = response.data.group_admin_ids;
        }
      });
    },
  },
  created() {
    auth.onChange = loggedIn => {
      this.loggedIn = loggedIn;
      this.getUsers();
      this.getGroups();
      this.loadGroupAdminScope();
    }
    this.getUsers();
    this.getGroups();
    this.loadGroupAdminScope();
  },
  beforeDestroy() {
  }
}
</script>

<style>
.group-picker {
  max-height: 240px;
  overflow-y: auto;
  border: 1px solid #ced4da;
  border-radius: 4px;
  padding: 4px;
}

.group-picker-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  border-radius: 3px;
}

.group-picker-item:hover {
  background-color: #f0f4ff;
}

.group-picker-item.selected {
  background-color: #e8f0fe;
}

.group-picker-label {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  font-weight: normal;
  cursor: pointer;
  user-select: none;
  flex: 1;
  min-width: 0;
}

.group-picker-label input[type="checkbox"] {
  margin: 0;
  cursor: pointer;
  flex-shrink: 0;
}

.group-picker-role {
  width: 120px;
  flex-shrink: 0;
}
</style>



// WEBPACK FOOTER //
// src/Users.vue